<template>
  <img v-if="thumbExists" :src="thumbSrc" class="course-name" />
</template>
<script>
import { IMPROVE_CONFIG } from "@/config.js";
import thumbSizes from "@/utils/thumbs.js";
export default {
  name: "TableThumb",
  props: {
    thumb: {
      type: Object,
      default: null
    }
  },
  computed: {
    thumbSrc: function() {
      return this.thumbExists ? this.transfrom(this.thumb.thumbnail.data.key) : null;
    },
    thumbExists: function() {
      return this.thumb.hasOwnProperty('thumbnail') ? true : false;
    },
  },
  methods: {
    transfrom(key) {
      const imageRequest = JSON.stringify({
        bucket: `${IMPROVE_CONFIG.BUCKET}`,
        key: key,
        edits: thumbSizes.small
      });      
      return `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(imageRequest)}`;
    }
  }
};
</script>
<style scoped>
.course-name {
  vertical-align: middle;
}
</style>